import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { ChangeSection } from './components/ChangeSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', '1005118822521193');
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3uct0zcywiaxb">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1005118822521193&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3udazkg91d18e" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white text-brand-ink" data-id="element-2" data-mp="86w6eufugc1w">
        <PurchasePopup data-id="element-3" data-mp="3gkl6xsz04y2b" />
        <main data-id="element-4" data-mp="3glwb3twd07ty">
          <Hero data-id="element-5" data-mp="3gja7248ogagh" />
          <PainSection data-id="element-6" data-mp="3bmbe3p0r29jv" />
          <SystemSection data-id="element-7" data-mp="3bmtgz4hx3m0r" />
          <BonusSection data-id="element-8" data-mp="3bnmf5h2t937a" />
          <ChangeSection data-id="element-9" data-mp="3bk70gfd1tw6e" />
          <PricingCard data-id="element-10" data-mp="3qaxrhl6tgr8g" />
          <Guarantee data-id="element-11" data-mp="3qbfud0nzi3pc" />
          <Testimonials data-id="element-12" data-mp="3qcr0360zplj3" />
          <FAQ data-id="element-13" data-mp="3qdajkr6aghz8" />
          <FinalCTA data-id="element-14" data-mp="3lkhge7qgxhp9" />
        </main>
        <Footer data-id="element-15" data-mp="3ljg1tta8ud2s" />
      </div>
    </>;
}